module.exports = __webpack_public_path__ + "images/dingtalk/init-member-todo-1f69c47df3b8812b1ea88c906e1f8e7f.png";